/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountNavTrigger_user = {
    readonly profile: {
        readonly firstName: string | null;
    } | null;
    readonly isVerifiedTrade: boolean | null;
    readonly tradeFirmRewards?: {
        readonly currentYearPoints: number | null;
        readonly currentProgram: {
            readonly programInfo: {
                readonly displayName: string | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": "AccountNavTrigger_user";
};
export type AccountNavTrigger_user$data = AccountNavTrigger_user;
export type AccountNavTrigger_user$key = {
    readonly " $data"?: AccountNavTrigger_user$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountNavTrigger_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "AccountNavTrigger_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasTradeUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "firstName",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasTradeUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tradeFirmRewards",
          "storageKey": null,
          "args": null,
          "concreteType": "TradeFirmRewards",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "currentYearPoints",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "currentProgram",
              "storageKey": null,
              "args": null,
              "concreteType": "ParentProgram",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "programInfo",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LoyaltyProgram",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "displayName",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '76603bbb19c0cb9719c2592462d9c0f9';
export default node;
